import React from 'react';

const NewDrawingOfficeWorkPackageStatuses = React.lazy(() => import("./new"))
const EditDrawingOfficeWorkPackageStatuses = React.lazy(() => import("./edit"))

export default[
	{path:'/drawing_office/work_package_statuses/:id/edit',component: EditDrawingOfficeWorkPackageStatuses,name:'Edit DrawingOfficeWorkPackageStatus'},
	{path:'/drawing_office/work_package_statuses/new',component: NewDrawingOfficeWorkPackageStatuses,name:'New DrawingOfficeWorkPackageStatus'},
]

// import DrawingOfficeWorkPackageStatusesRoutes from "modules/drawing_office/work_package_statuses/web/routes"
// routes = _.concat(routes,DrawingOfficeWorkPackageStatusesRoutes)
